import { request } from '@umijs/max';
import { fetchCurrentUserInfo } from '@/services/sd/user';
import type { UserFormItems } from './data';

export type UpdateUserParams = Partial<UserFormItems> & {
  adminRole?: string;
};

export type UpdateUserPasswordParams = {
  password: string;
  passwordConfirmation: string;
};

export async function getUserInfo() {
  return fetchCurrentUserInfo({ preferCache: true });
}

export async function getNotificationPreference() {
  return request('/api/sys-user-notify/current', {
    method: 'POST',
  });
}

export async function updateNotificationPreference(data: {
  emailEnabled: boolean | number;
  emailEventTypes: string[];
  appUuids: string[];
}) {
  return request('/api/sys-user-notify/update', {
    method: 'POST',
    data,
  });
}

export async function getAvailableAppsForCurrentUser(payload: {
  userUuid?: string;
  isSuperAdmin?: number;
}) {
  return request('/api/application/items', {
    method: 'POST',
    data: {
      page: 1,
      size: 1000,
      status: 1,
      ...(payload.isSuperAdmin === 1
        ? {}
        : { userUuid: payload.userUuid || undefined }),
    },
  });
}

/**
 * 修改用户
 */
export async function updateUser(uuid: string, data: UpdateUserParams) {
  return request(`/api/sys-user/update/${uuid}`, {
    method: 'POST',
    data,
  });
}

/**
 * 修改用户密码
 */
export async function updateUserPassword(
  uuid: string,
  data: UpdateUserPasswordParams,
) {
  return request(`/api/sys-user/updatePassword/${uuid}`, {
    method: 'POST',
    data,
  });
}
